export class MonthEnergyCost {
    constructor({
          id= null,         
          month= ``,
          locName= ``, 
          energyName= ``,
          energyCode= ``,         
          energyCost= ``,
          unit= ``,
          
      } = {}) {
      this.id = id;     
      this.month = month;
      this.locName = locName;     
      this.energyName = energyName;
      this.energyCode = energyCode;
      this.energyCost = energyCost;
      this.unit = unit;     
    }
  }
  export function gridFields() {
    return Object.freeze([         
        {
          key: 'locName',
          label: 'lbl.basic.locName',
          sortable: true,
          form: {
            type: 'input'
          } 
        }, 
        {
          key: 'month',
          label: 'lbl.basic.month',
          sortable: true,
          form: {
            type: 'month'
          }
        },                              
        {
          key: 'energyName',
          label: 'lbl.basic.energyName',
          sortable: false,
          form: {
            type: 'input'
          }
        }, 
        {
          key: 'energyCode',
          label: 'lbl.basic.energyCode',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'energyCost',
          label: 'lbl.prd.execution.energyCost',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'unit',
          label: 'lbl.basic.unit',
          sortable: false,
          form: {
            type: 'input'
          }
        }
    ]);
  }
  export const fields = Object.freeze(Object.keys(new MonthEnergyCost()).map(i => 'entity.' + i));
  export const filterFields = [
    'filter.plantFilter',
    'filter.startMonthFilter',
    'filter.endMonthFilter', 
    'filter.energyFilter',     
  ];
  export const filter = {
    'plantFilter': "",
    'startMonthFilter': "",
    'endMonthFilter': "",
    'energyFilter': "",
  };